import Alpine from 'alpinejs'
import EmblaCarousel from 'embla-carousel'
import Autoplay from 'embla-carousel-autoplay'

Alpine.data('carousel', (options = {}) => ({
    embla: null,
    selectedIndex: 0,
    slideCount: 0,

    init() {
        const slides = this.$refs.viewport.querySelectorAll('[data-carousel-slide]')
        this.slideCount = slides.length

        if (this.slideCount <= 1) return

        this.embla = EmblaCarousel(this.$refs.viewport, { loop: true, ...options }, [Autoplay({ delay: 5000, stopOnInteraction: true })])

        this.embla.on('select', () => {
            this.selectedIndex = this.embla.selectedScrollSnap()
        })
    },

    prev() {
        this.embla?.scrollPrev()
    },

    next() {
        this.embla?.scrollNext()
    },

    scrollTo(index) {
        this.embla?.scrollTo(index)
    },

    destroy() {
        this.embla?.destroy()
    },
}))
